import { PlaybookWindowOption } from 'src/pages/solve-config/playbook-tab/constants';
import {
  ApiConfiguration,
  ChannelType,
  EmailConfiguration,
  GeneralInstructionConfig,
  PlaybookConfiguration,
  SlackConfiguration,
  VoiceConfiguration,
  WidgetConfiguration,
} from 'src/slices/solve-config/types';

const countWords = (text: string): number => {
  if (!text || typeof text !== 'string') {
    return 0;
  }

  return text
    .trim()
    .split(/\s+/)
    .filter(word => word.length > 0).length;
};

export const isValidWordCount = (text: string, maxWords = 1000): boolean => {
  return countWords(text) <= maxWords;
};

export const validateGeneralInstructionConfig = (
  generalInstructionConfig: GeneralInstructionConfig,
): boolean => {
  const {
    general_context: context,
    glossary,
    is_enabled: isEnabled,
  } = generalInstructionConfig;
  if (!isEnabled) {
    return true; // No validation needed if not enabled
  }
  if (context && !isValidWordCount(context)) {
    return false; // Context exceeds word limit
  }
  if (glossary && !isValidWordCount(glossary)) {
    return false; // Glossary exceeds word limit
  }

  return true;
};

export const getGeneralInstructionConfig = ({
  channel,
  configuration,
  selectedPlaybookOption,
}: {
  channel: ChannelType;
  configuration:
    | PlaybookConfiguration
    | WidgetConfiguration
    | ApiConfiguration
    | EmailConfiguration;
  selectedPlaybookOption: PlaybookWindowOption;
}) => {
  if (channel !== 'playbook') {
    return configuration.general_instruction_config;
  }

  if (selectedPlaybookOption === 'generated_reply') {
    return (configuration as PlaybookConfiguration)
      .reply_generation_general_instruction_config;
  }

  return configuration.general_instruction_config;
};

export const getConfigurationByChannel = ({
  apiConfiguration,
  channel,
  emailConfiguration,
  playbookConfiguration,
  slackConfiguration,
  voiceConfiguration,
  widgetConfiguration,
}: {
  apiConfiguration: ApiConfiguration;
  channel: ChannelType;
  emailConfiguration: EmailConfiguration;
  playbookConfiguration: PlaybookConfiguration;
  slackConfiguration: SlackConfiguration;
  voiceConfiguration: VoiceConfiguration;
  widgetConfiguration: WidgetConfiguration;
}) => {
  switch (channel) {
    case 'slack':
      return slackConfiguration;
    case 'api':
      return apiConfiguration;
    case 'voice':
      return voiceConfiguration;
    case 'playbook':
      return playbookConfiguration;
    case 'email':
      return emailConfiguration;
    default:
      return widgetConfiguration;
  }
};
